import { GraphQlRequestService } from '../../../api/graphql-request-service';
import { hashString } from '../types';
import { handleGQLErrors } from '../utils';
import { IpAddressService } from './service';

export class GraphQlIpAddressService implements IpAddressService {
  constructor(
    readonly graphQlRequestService: GraphQlRequestService,
    readonly simulateRole: string | null
  ) {}

  public getDeps = () => [
    hashString([...this.graphQlRequestService.getDeps()]),
  ];

  public detectIpAddress = async (): Promise<string | null> => {
    const result = await handleGQLErrors(
      this.graphQlRequestService.graphQlSdk.detectIpAddress({
        simulateRole: this.simulateRole,
      })
    );
    return result.detectIpAddress;
  };
}
